
import Vue from 'vue'

const getDefaultState = () => {
    return {
        serviceProjectSetup: {
            id: 0,
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`serviceproject-setup/list`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const list = result.data.result;

                return list;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list service project setups: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`serviceproject-setup/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get service project setup`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get service project setup: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, request) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post(`serviceproject-setup/create-update`, request,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (request.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    success: true,
                    idServiceProjectSetup: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    idServiceProjectSetup: 0,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`serviceproject-setup/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
    
    async Delete(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.delete(`serviceproject-setup/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                return {
                    success: true,
                    message: "Register deleted with success!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to delete the register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to delete the register: [${error}]`
                };
            }
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.serviceProjectSetup, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.serviceProjectSetup;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
